import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const ShopSettingsContext = createContext(null);

export const ShopSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ showcase_mode: true, tiktok_shop_url: "", loaded: false });
  const reload = useCallback(
    () => api.get("/settings").then(({ data }) => setSettings({ ...data, loaded: true })).catch(() => setSettings((s) => ({ ...s, loaded: true }))),
    []
  );
  useEffect(() => { reload(); }, [reload]);
  return <ShopSettingsContext.Provider value={{ ...settings, reload }}>{children}</ShopSettingsContext.Provider>;
};

export const useShopSettings = () => useContext(ShopSettingsContext);
